import _ from 'lodash'
import Papa from 'papaparse'
import Base from '@/resources/Base'
import { basicNameRe } from '@/utilities/regex/basic'

const whitelistFieldValidation = {
  name: [
    {
      min: 1,
      max: 256,
      required: true,
      trigger: 'blur',
      validator: function (rule, value, callback) {
        if (!value || !value.length) {
          callback(new Error('Please provide the whitelist name'))
        } else if (value.length > 256) {
          callback(new Error('Whitelist name length exceeds 256'))
        } else {
          basicNameRe.test(value)
            ? callback()
            : callback(new Error('Invalid whitelist name format'))
        }
      }
    }
  ],
  value: [
    {
      required: true,
      trigger: 'blur',
      validator: function (rule, value, callback) {
        if (!value || !value.length) {
          callback(new Error('Please provide the whitelist value.'))
        } else {
          callback()
        }
      }
    }
  ]
}

export default class RuleWhitelist extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.validationRules = whitelistFieldValidation
    if (this.key) {
      this.name = this.key
    }
    if (_.isUndefined(this.value)) {
      this.value = []
    }
    if (_.isUndefined(this.ruleIds)) {
      this.ruleIds = []
    }
    this.valuesCount = this.value.length
    this.rulesCount = this.ruleIds.length
    this.fileUploadError = {
      error: false,
      message: ''
    }
  }

  setValues (values) {
    this.value = values
  }

  clearInputProperties () {
    this.name = ''
    this.value = []
    this.ruleIds = []
    this.valuesCount = 0
    this.rulesCount = 0
  }

  removeValue (val) {
    let valueIdx = _.indexOf(this.value, val)
    if (valueIdx > -1) {
      this.spliceValue(valueIdx)
    }
  }

  updateValue (prevVal, newVal) {
    let valueIdx = _.indexOf(this.value, prevVal)
    if (valueIdx > -1) {
      this.value[valueIdx] = newVal
    }
  }

  spliceValue (valueIdx) {
    this.value.splice(valueIdx, 1)
  }

  parseCommaSpaceSeparatedValues (values) {
    let newValues = values.split(/(?:,| )+/) // ignores empty between commas
    let validValues = []
    newValues.forEach(element => {
      if (!_.isEmpty(element)) {
        validValues.push(element)
      }
    })
    return validValues
  }

  transformRuleIds (rules) {
    this.ruleIds = _.map(this.ruleIds, ruleId => {
      return _.find(rules, { id: ruleId }) || ruleId
    })
  }

  importCsvValues (evt, file) {
    this.fileUploadError.error = false

    let reader = new FileReader()
    reader.readAsText(file, 'UTF-8')
    reader.onload = evt => {
      if (file.type === 'text/csv') {
        let csvToJSON = Papa.parse(evt.target.result, {
          header: false,
          delimiter: ',', // auto-detect
          skipEmptyLines: 'greedy'
        })
        if (_.isEmpty(csvToJSON.errors)) {
          csvToJSON.data = _.flatten(csvToJSON.data)
          let uploadVal = csvToJSON.data.join(',')
          let validValues = this.parseCommaSpaceSeparatedValues(uploadVal)
          if (_.isEmpty(validValues)) {
            this.fileUploadError.error = true
            this.fileUploadError.message = 'File contains invalid values'
          }
          this.value = this.value.concat(validValues)
        } else {
          csvToJSON.errors.forEach(error => {
            this.fileUploadError.error = true
            this.fileUploadError.message = error
            console.log(error)
          })
        }
      }
    }
    reader.onerror = evt => {
      console.error(evt)
    }
  }

  preparePostbody () {
    return {
      key: this.name,
      field: this.field,
      value: this.value,
      ruleIds: _.map(this.ruleIds, 'id')
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/allowlist/RuleWhitelist.js